import { AuthCloseIcon } from "@layouts/betto/authPopup/icons/AuthCloseIcon.jsx";
import PropTypes from "prop-types";
import React, { memo } from "react";

import { BettoAlertIllustrationImage } from "./BettoAlertIllustration.jsx";
import {
	BettoAlertActions,
	BettoAlertCard,
	BettoAlertCloseButton,
	BettoAlertContent,
	BettoAlertCopy,
	BettoAlertMessage,
	BettoAlertOverlay,
	BettoAlertPrimaryButton,
	BettoAlertSecondaryButton,
	BettoAlertTitle,
} from "./BettoAlertModal.styles";

export const BettoAlertModal = memo(
	({
		title,
		message,
		illustrationKey,
		buttons,
		showClose = true,
		onClose,
		onButtonClick,
	}) => (
		<BettoAlertOverlay data-id="betto-alert-modal">
			<BettoAlertCard>
				{showClose ? (
					<BettoAlertCloseButton
						type="button"
						data-testid="button-alert-close"
						onClick={onClose}
						aria-label="Close">
						<AuthCloseIcon />
					</BettoAlertCloseButton>
				) : null}

				<BettoAlertIllustrationImage illustrationKey={illustrationKey} />

				<BettoAlertContent>
					<BettoAlertCopy>
						<BettoAlertTitle data-testid="label-alert-title">{title}</BettoAlertTitle>
						<BettoAlertMessage data-testid="label-alert-message">
							{message}
						</BettoAlertMessage>
					</BettoAlertCopy>

					{buttons?.length ? (
						<BettoAlertActions>
							{buttons.map((button) => {
								const ButtonComponent =
									button.variant === "secondary"
										? BettoAlertSecondaryButton
										: BettoAlertPrimaryButton;

								return (
									<ButtonComponent
										key={`${button.action}-${button.label}`}
										type="button"
										$fullWidth={button.fullWidth}
										data-testid={`button-alert-${button.action}`}
										onClick={() => onButtonClick(button)}>
										{button.label}
									</ButtonComponent>
								);
							})}
						</BettoAlertActions>
					) : null}
				</BettoAlertContent>
			</BettoAlertCard>
		</BettoAlertOverlay>
	)
);

BettoAlertModal.displayName = "BettoAlertModal";

BettoAlertModal.propTypes = {
	title: PropTypes.string.isRequired,
	message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	illustrationKey: PropTypes.string.isRequired,
	buttons: PropTypes.arrayOf(
		PropTypes.shape({
			variant: PropTypes.oneOf(["primary", "secondary"]).isRequired,
			label: PropTypes.string.isRequired,
			action: PropTypes.string.isRequired,
			fullWidth: PropTypes.bool,
		})
	),
	showClose: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	onButtonClick: PropTypes.func.isRequired,
};
